export enum CalculatedFieldTable {
	CONTACT_ADDRESS = "ContactAddress",
	CONTACT_EXTRA_FIELDS = "ContactExtraFields",
	CONTACT_GROUP = "ContactGroup",
	LEDGER_ACCOUNT = "LedgerAccount",
	CONTACT = "Contact",
	SALE_EXTRA_FIELDS = "SaleExtraFields",
	SALE_HISTORY = "SaleHistory",
	PRODUCT_COMPOSITION_ROW = "ProductCompositionRow",
	PRODUCT_EXTRA_FIELDS = "ProductExtraFields",
	PRODUCT_SUPPLIER = "ProductSupplier",
	PRODUCT_STOCK = "ProductStock",
	PRODUCT_WRITE_OFF_ROW = "ProductWriteOffRow",
	PRODUCT_GROUP_MODEL = "ProductGroupModel",
	PRODUCT_GROUP_PRODUCT = "ProductGroupProduct",
	UNIT = "Unit",
	PRODUCT = "Product",
	SALE_ROW = "SaleRow",
	SALE_TYPE = "SaleType",
	SALE = "Sale",
	FREQUENCY_DOCUMENT = "FrequencyDocument",
	PRODUCT_IMAGE = "ProductImage",
	VAT = "Vat",
	STOCK_IN = "StockIn",
	BOOK_YEAR = "BookYear",
	BANK_TYPE = "BankType",
	BANK = "Bank",
	CRM_STATUS = "CrmStatus",
	CRM_HISTORY_CALL = "CrmHistoryCall",
	CRM_HISTORY_APPOINTMENT = "CrmHistoryAppointment",
	CRM_HISTORY_MESSAGE = "CrmHistoryMessage",
	CRM_HISTORY_EMAIL = "CrmHistoryEmail",
	CRM_HISTORY_CLOSE = "CrmHistoryClose",
	CRM_HISTORY = "CrmHistory",
	CRM_ASSIGNED_USER = "CrmAssignedUser",
	CRM = "Crm",
	CAR = "Car",
	PURCHASE_LEDGER = "PurchaseLedger",
	PURCHASE = "Purchase",
	DIVERSE_LEDGER = "DiverseLedger",
	BANK_BALANCE = "BankBalance",
	PRODUCT_GROUP = "ProductGroup",
	}


// eslint-disable-next-line max-lines-per-function
export function getAllCalculatedFieldTables():CalculatedFieldTable[] {
	return Object.values(CalculatedFieldTable).sort();
}
